import axios from 'axios'
import {
  MARGIN_CALLS_API,
  MARGIN_POSITION_API,
  MARGINS_API,
  WITH_CREDENTIALS_CONFIG,
} from './constants'

export const getAccountPositions = (
  accountNumber: string,
  processDate?: string
) => {
  const processDateQueryString = processDate
    ? `?processDate=${processDate}`
    : ''

  return axios.get(
    `${MARGIN_POSITION_API}/${accountNumber}/totals${processDateQueryString}`,
    WITH_CREDENTIALS_CONFIG
  )
}

export const getMarginCalls = (accountNumber: string) =>
  axios.get(`${MARGIN_CALLS_API}/${accountNumber}`, WITH_CREDENTIALS_CONFIG)

export const getMargins = (accountNumber: string) =>
  axios.get(`${MARGINS_API}/${accountNumber}`, WITH_CREDENTIALS_CONFIG)
